<div id="invTransactionImport-list" class="flex flex-col gap-2 bg-neutral-800 rounded-sm mb-2">
  @if (loading()) {
    <p-skeleton height="2rem"/>
    <p-skeleton height="2rem"/>
    <p-skeleton height="2rem"/>
  } @else {
    @for (trans of transactions(); track trans._id) {
      <inv-transaction-list-item
        [transaction]="trans"
        [showViewButton]="false"
        [showPrintButton]="false"
        [showSelectButton]="true"
        (selected)="selectedTransaction(trans)"
      >
      </inv-transaction-list-item>
    }
  }
</div>

<div class="flex justify-end gap-2">
  <p-button [label]="'general.cancel' | translate" severity="secondary" (onClick)="closeDialog()" />
</div>
